const metrics = [
    { value: "04", label: "asset classes being acquired", testid: "stat-asset-classes" },
    {
        value: "01",
        label: "operating partner (Legacy Transit Solutions)",
        testid: "stat-operating-partner",
    },
    { value: "100%", label: "of the fleet leased to LTS", testid: "stat-fleet-leased" },
];

export default function PlanByNumbers() {
    return (
        <section id="plan" data-testid="plan-section" className="py-24 px-6">
            <div className="max-w-7xl mx-auto">
                <p className="font-mono2 text-xs uppercase tracking-widest text-amber-500 mb-4">
                    Acquisition Roadmap
                </p>
                <h2
                    data-testid="plan-by-numbers-title"
                    className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-14"
                >
                    The plan, by the numbers
                </h2>
                <div className="grid sm:grid-cols-3 gap-6 mb-14">
                    {metrics.map((m) => (
                        <div
                            key={m.testid}
                            data-testid={m.testid}
                            className="border border-white/10 bg-white/[0.03] rounded-lg p-8 hover:border-amber-500/40 transition-colors duration-300"
                        >
                            <p className="font-display text-5xl lg:text-6xl font-bold text-amber-500 mb-3">
                                {m.value}
                            </p>
                            <p className="text-sm text-slate-300 leading-relaxed">{m.label}</p>
                        </div>
                    ))}
                </div>
                <div className="border border-amber-500/30 bg-amber-500/10 rounded-lg px-8 py-6 text-center">
                    <p
                        data-testid="acquiring-units-tagline"
                        className="font-display text-xl sm:text-2xl font-semibold text-amber-400 tracking-wide"
                    >
                        We&rsquo;re acquiring our first units now.
                    </p>
                </div>
            </div>
        </section>
    );
}
